import { isAuthGuardActive } from '../constants/config';
import { setCurrentUser, getCurrentUser } from '.';
import axios from "axios";
// axios.defaults.headers.common["Authorization"] =
//     "Bearer " + localStorage.getItem("token_admin");


export default async (to, from, next) => {
    if (to.matched.some(record => record.meta.loginRequired)) {
        if (isAuthGuardActive) {
            const user = getCurrentUser();
            if (user && localStorage.getItem('token_admin')) {
                try {
                    let email = user.email;
                    let tk = localStorage.getItem('token_admin');
                    console.log('disparando axios a validate');

                    let response = await axios.post(`${process.env.VUE_APP_HOST}/api/dashboard/admin/validate`, {}, {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem("token_admin")}`,
                            'X-Custom-Header': 'customHeaderValue'
                        }
                    });
                    console.log('response', response);
                    user.role = response.data.role;
                    setCurrentUser(user);

                    console.log('message:', response.data.message);

                    if (!response.data.success) {
                        console.log('error en sesion...');
                        localStorage.removeItem('token_admin');
                        setCurrentUser(null);
                        next('/user/login');
                    } else {
                        const roleArrayHierarchic = to.matched.filter(x => x.meta.roles).map(x => x.meta.roles);
                        if (roleArrayHierarchic.every(x => x.includes(user.role))) {
                            next();
                        } else {
                            next('/unauthorized');
                        }
                    }
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        console.log('Error 401: No autorizado');
                        setCurrentUser(null);
                        next('/user/login');
                    } else {
                        console.error('Error durante la validación:', error);
                        // next('/error');
                        next('/user/login');
                    }
                }
            } else {
                setCurrentUser(null);
                next('/user/login');
                console.log('token:', localStorage.getItem('token_admin'));
            }
        } else {
            next();
        }
    } else {
        next();
    }
}



// export default async (to, from, next) => {
//     if (to.matched.some(record => record.meta.loginRequired)) {
//         if (isAuthGuardActive) {
//             const user = getCurrentUser();
//             if (user && localStorage.getItem('token_admin')) {
//                 console.log('no hay token')
//                 let email = user.email;
//                 let tk = localStorage.getItem('token_admin')
//                 let response = await axios.post(`${process.env.VUE_APP_HOST}/api/dashboard/admin/validate`, { email: email, validar: 1, token: tk });

//                 user.role = response.data.role;
//                 setCurrentUser(user);

//                 console.log('message:', response.data.message)

//                 if (response.data.message == 'error') {
//                     setCurrentUser(null);
//                     next('/user/login');
//                 } else {
//                     const roleArrayHierarchic = to.matched.filter(x => x.meta.roles).map(x => x.meta.roles);
//                     if (roleArrayHierarchic.every(x => x.includes(user.role))) {
//                         next();
//                     } else {
//                         next('/unauthorized')
//                     }
//                 }

//             } else {
//                 setCurrentUser(null);
//                 next('/user/login')
//                 console.log('token:', localStorage.getItem('token_admin'))
//             }
//         } else {
//             next();
//         }
//     } else {
//         next()
//     }
// }